/* 
  USB util service: 
  getDeviceName
  setDeviceName
  
*/
import { Plugin } from "plugin";
import { getDeviceName, setDeviceName } from "../peripherals/usbutil.js";


class Service extends Plugin {
  constructor(...args) {
    super(...args);
  }
  async RM_usbutil_getDeviceName(event, usbSerialNumber) {
    return getDeviceName(usbSerialNumber);
  }
  async RM_usbutil_setDeviceName(event, usbSerialNumber, name) {   
    setDeviceName(usbSerialNumber, name);
  }
}

export default Service;